/*
 * Typed wrappers over the goserver SALES role membership endpoints
 * (SUPER_USER only; 403 otherwise).
 */

import {
  delete_api as deleteApi,
  get_api as getApi,
  post_api as postApi
} from '../../../../redux/api_funcs';
import { get_api_url as getApiUrl } from '../../../../utils/urls';

const BASE = '/v2/cms_user/manage/roles/SALES/members';

export interface RoleUser {
  uuid: string;
  name: string;
  email: string;
  is_active: boolean;
}

export interface RoleMembers {
  members: RoleUser[];
  candidates: RoleUser[];
}

interface Envelope<T> {
  data?: { data?: T };
}

export interface ApiError {
  response?: { status?: number; data?: { reason?: string; message?: string } };
}

const list = (v: unknown): RoleUser[] => (Array.isArray(v) ? (v as RoleUser[]) : []);

export const fetch_sales_members = (): Promise<RoleMembers> =>
  getApi(getApiUrl(BASE), true).then((res: Envelope<Partial<RoleMembers>>) => {
    const d = res?.data?.data;
    return { members: list(d?.members), candidates: list(d?.candidates) };
  });

export const add_sales_member = (uuid: string): Promise<void> =>
  postApi(getApiUrl(BASE), { uuid }, true).then(() => undefined);

export const remove_sales_member = (uuid: string): Promise<void> =>
  deleteApi(getApiUrl(`${BASE}/${encodeURIComponent(uuid)}`), true).then(() => undefined);

export const api_status = (e: unknown): number | undefined =>
  (e as ApiError | null)?.response?.status;

export const api_error_reason = (e: unknown, fallback: string): string => {
  const data = (e as ApiError | null)?.response?.data;
  return data?.reason || data?.message || fallback;
};
